import React from 'react';
import ProductOfferCarousel from './related-products-offer';

// remove when data is set from API 
import {productCarouselData} from './offers-carousel.mock';

const RelatedOffersCarousel = () => {
    return <ProductOfferCarousel products={productCarouselData} />;
};

export default RelatedOffersCarousel;